export default __webpack_public_path__ + "static/media/dino.2d22931d.webm";